import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';

import { createStore } from '@redux';
import App from './App';
import './index.css';
import '@toast-ui/editor/dist/toastui-editor-viewer.css';

const store = createStore(undefined);
window['store'] = store;
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);


